export enum FormaPagamentoDividendoEnum {
  Especie = 1,
  TransferenciaBancaria = 2
}

export enum FormaDistribuicaoDividendoEnum {
  Regular = 1,
  Antecipacao = 2
}

export enum ModoDistribuicaoBeneficiarioEnum {
  Proporcional = 1,
  Individualizado = 2
}

export enum StatusDividendoEnum {
  Pendente = 1,
  Pago = 2,
  Cancelado = 3
}

export enum StatusReinfDividendoEnum {
  NaoEnviado = 1,
  Enviado = 2,
  Retificado = 3,
  Erro = 4,
  Excluido = 5
}
